import { Check, ChevronDown, UserCog } from "lucide-react";
import { toast } from "sonner";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuLabel, DropdownMenuSeparator, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { useApp } from "@/context/AppContext";

export function PersonaSwitcher() {
  const { personas, persona, setPersona } = useApp();
  if (!persona) return null;
  return (
    <DropdownMenu>
      <DropdownMenuTrigger data-testid="persona-switcher" className="flex items-center gap-2 text-xs text-slate-600 hover:text-slate-900 border border-slate-200 rounded-full pl-1 pr-2.5 py-1 transition-colors">
        <span className="w-6 h-6 rounded-full bg-sky-600 text-white flex items-center justify-center text-[10px] font-semibold">{persona.initials}</span>
        <span className="hidden sm:flex flex-col items-start leading-tight"><span className="text-slate-900 font-medium" data-testid="current-persona-name">{persona.name}</span><span className="text-[10px] text-slate-500">{persona.role}</span></span>
        <ChevronDown className="w-3 h-3" />
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="w-80 max-h-[75vh] overflow-y-auto thin-scroll bg-white border-slate-200">
        <DropdownMenuLabel className="flex items-center gap-1.5 text-xs text-slate-500"><UserCog className="w-3.5 h-3.5" />Switch persona - role-based access</DropdownMenuLabel>
        <DropdownMenuSeparator />
        {personas.map((p) => (
          <DropdownMenuItem key={p.id} data-testid={`persona-option-${p.id}`} onClick={() => { setPersona(p.id); toast.success(`Now acting as ${p.name} (${p.role})`); }} className="flex items-start gap-2 py-2 cursor-pointer">
            <span className="w-6 h-6 shrink-0 rounded-full bg-slate-100 text-slate-700 flex items-center justify-center text-[10px] font-semibold">{p.initials}</span>
            <span className="flex-1"><span className="block text-sm text-slate-900">{p.name} <span className="text-[11px] text-slate-500">· {p.role}</span></span><span className="block text-[11px] text-slate-500">{p.summary}</span></span>
            {p.id === persona.id && <Check className="w-4 h-4 text-sky-600" />}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
}
